<template>
  <div class="lds-ring">
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
export default {
  name: 'SimplePreloader'
};
</script>

<style lang="scss" scoped>
.lds-ring-white {
  &::before {
    background: #fff;
  }
  &::after {
    background-color: #409fff;
  }
  div {
    border: 4px solid #fff;
    border-color: #fff transparent transparent transparent;
  }
}
.lds-ring:after {
  background: none !important;
}
</style>
